import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import TkVisualizer from '@/../bower_components/teknisavuecomponents/components/document/TkVisualizer/TkVisualizer.vue';
import ReconhecimentoFacialController from '@/assets/ts/controller/ReconhecimentoFacialController';
import NovoRegistroBiometriaFacialPopup from '@/components/biometria/NovoRegistroBiometriaFacialPopup/NovoRegistroBiometriaFacialPopup.vue';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'BiometriaDetalhes',
  components: {
    EditableTable,
    TkVisualizer,
    NovoRegistroBiometriaFacialPopup
  }
})
class BiometriaDetalhes extends Vue {
  // #region [ PROPS ]
  @Prop({ default: '' })
  private readonly nrParcnegocio: string;

  @Prop({ default: '' })
  private readonly nmvinculom: string;

  @Prop({ default: 0 })
  private readonly triggerReload: number;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}

  // #endregion

  //#region [ DATA ]
  private internalValue = false;
  private title = 'Biometrias Cadastradas';

  private columns = [
    {
      value: 'NRFACEID',
      text: 'Nr. Face',
      type: 'text',
    },
    {
      value: 'DTINCLUSAO',
      text: 'Data de Inclusão',
      type: 'date',
    },
  ];

  private biometrias = [];
  private nrFaceId = null;
  private isOpenModalBiometria = false;
  private isBiometriaEdit = false;

  private loading = false;

  private actions = [
    {
      label: 'Editar',
      value: 'editar',
      icon: 'mdi-pencil',
      onClick: ControleAcessoWrapper.criar(this.edit),
      mode: 'view',
    },
    {
      name: 'delete',
      label: 'Excluir',
      icon: 'mdi-delete',
      onClick: ControleAcessoWrapper.deletar(this.delete),
      mode: 'view',
    },
  ];

  private toolbarActions = [
    {
      name: 'reload',
      label: 'Atualizar',
      icon: 'mdi-refresh',
      onClick: this.reloadBiometrias,
    },
    {
      name: 'add',
      label: 'Adicionar',
      icon: 'mdi-plus-circle',
      onClick: ControleAcessoWrapper.criar(this.add),
    },
  ];

  //#endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.reloadBiometrias();
    }
  }

  @Watch('triggerReload')
  private trigeerReloadOnChange() {
    this.reloadBiometrias();
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async reloadBiometrias() {
    this.loading = true;
    this.biometrias = [];

    try {
      const biometrias = await ReconhecimentoFacialController.getBiometriasVinculo(this.nrParcnegocio);

      biometrias.forEach((doc) => {
        doc.DTINCLUSAO = doc.DTINCLUSAO.replace(' 00:00:00', '');
      });

      this.biometrias = biometrias;
    } finally {
      this.loading = false;
    }
  }

  private add() {
    this.isBiometriaEdit = false;
    this.nrFaceId = null;
    this.isOpenModalBiometria = true;
  }

  private edit(row: any) {
    this.isBiometriaEdit = true;
    this.nrFaceId = row.NRFACEID;
    this.isOpenModalBiometria = true;
  }

  private async delete(row: any) {
    const nrFaceId = row.NRFACEID;

    this.loading = true;
    try {
      await ReconhecimentoFacialController.deleteHashFacial(nrFaceId, this.nrParcnegocio);
      this.reloadBiometrias();
    } finally {
      this.loading = false;
    }

  }
  // #endregion
}

export default BiometriaDetalhes;